var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2482_7900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 0.975586H3.33317C2.4165 0.975586 1.6665 1.72559 1.6665 2.64225V14.3089H3.33317V2.64225H13.3332V0.975586ZM15.8332 4.30892H6.6665C5.74984 4.30892 4.99984 5.05892 4.99984 5.97559V17.6423C4.99984 18.5589 5.74984 19.3089 6.6665 19.3089H15.8332C16.7498 19.3089 17.4998 18.5589 17.4998 17.6423V5.97559C17.4998 5.05892 16.7498 4.30892 15.8332 4.30892ZM15.8332 17.6423H6.6665V5.97559H15.8332V17.6423Z",
    fill: "#4B4B4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2482_7900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.142578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.61e32e5ec2f09d0dec0b06066b63dff2.svg";
export { ForwardRef as ReactComponent };